<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="10" :lg="11" :md="12" :sm="24">
            <a-form-item :label="language['eletronicSigned.queryDate']">
              <j-date :placeholder="language['common.chooseStartDate']" :showTime="false" :defaultValue="moment(queryParam.beginDate, 'YYYY-MM-DD')" dateFormat="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.beginDate"></j-date>
              <span class="query-group-split-cust"></span>
              <j-date :placeholder="language['common.chooseEndDate']" :showTime="false" :defaultValue="moment(queryParam.endDate, 'YYYY-MM-DD')" dateFormat="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.endDate"></j-date>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.processName']">
              <a-select v-model="queryParam.formId" allowClear >
                <a-select-option v-for="(model,index) in allProcess" :key="index" :value="model.formId" >
                  {{ model.formName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.processNo']">
              <a-input  v-model="queryParam.processNo" allowClear></a-input><!--placeholder="输入流程编号"-->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.businessFormNo']">
              <a-input  v-model="queryParam.businessFormNo" allowClear></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="search_reset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>{{language['common.choosed']}}&nbsp;<a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>{{language['common.item']}}&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>-->

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      ><!--:scroll="{x:2000}"-->

        <template slot="processChartLot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-icon type="cluster" @click="openChart(record)" style="color:#33A1FF"/>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
          <!--<span v-if="record.process_status == 'Rejected' || record.process_status == 'Withdrawn'">
            <a-divider type="vertical"/>
            <a-popconfirm title="确定删除吗?" @confirm="() => handle_delete(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>-->
          <!--<span v-if="record.processStatus == 'Rejected' || record.processStatus == 'Withdrawn'">
            <a-divider type="vertical"/>
            <a @click="handle_cancel(record)">{{language['eletronicSigned.termination']}}</a>
          </span>-->
          <span v-if="record.processStatus == 'Started'
                      || record.processStatus == 'Restarted'
                      || record.processStatus == 'InProcess'">
            <a-divider type="vertical"/>
            <a @click="handle_cancel(record)">{{language['eletronicSigned.termination']}}</a>
          </span>
        </span>

        <span slot="task_status" slot-scope="text, record">
          {{ text === 'Cancelled' ? language['eletronicSigned.termination'] : record.task_status_local_lang }}
        </span>
        <!--<span slot="businessFormNo" slot-scope="text, record">
          <p style="color: red;font-weight: 500;" v-if="record.process_status === 'Rejected'||record.process_status === 'ReturnTo'">{{text}}</p>
          <p  v-else>{{text}}</p>
        </span>-->

      </a-table>
    </div>
    <!-- table区域-end -->

    <my-apply-modal ref="modalForm" @ok="modalFormOk"></my-apply-modal>
    <comments-modal ref="commentsModal"  @reSeach="searchQuery"></comments-modal>

    <a-modal
      :mask="false"
      :width="1200"
      :title="language['eletronicSigned.processChart']"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :ok-button-props="{ props: { disabled: true } }"
      @cancel="handleCancel"
      :cancelText="language['common.closeButton']">
      <div style="padding: 20px;overflow-x: scroll;">
        <div>
          <a-steps  size="small">
            <a-step :title="language['bpm.sign.startTaskName']" status="finish">
              <template slot="description">
                <p style="color:green" slot="title">{{selectedChartData.createUserRealname}}</p>
              </template>
            </a-step>
            <a-step  :title="item.taskName" v-for="(item,index) in chartList" :key="index"
                     :status="item.taskStatus=='Ready'?'process':(item.taskStatus=='Rejected'?'error':(item.taskStatus=='Completed'?'finish':'wait'))" >
              <template slot="description">
                <p slot="title" v-for="(signUser,i) in item.signUsers" :key="i"
                   :style="(selectedChartData.processStatus=='Cancelled')?(signUser.isSign==1?'color:green':''):(signUser.isSign==1?'color:green':(signUser.ready?'color:red':''))" >
                  {{signUser.userCodeName}}
                </p>
              </template>
            </a-step>
            <a-step :title="language['bpm.sign.endTaskName']" description="" :status="selectedChartData.processStatus == 'Completed'?'finish':'wait'"/>
          </a-steps>
        </div>
      </div>
    </a-modal>

  </a-card>
</template>

<script>
  import MyApplyModal from './modules/MyApplyModal'
  import {putAction, getFileAccessHttpUrl,getAction} from '@/api/manage';
  import CommentsModal from './modules/CommentsModal'
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'
  import moment from "moment";
  import {withdraw} from "./auditJS/withdraw"
  import {cancel} from "./auditJS/cancel"

  export default {
    name: "MyApplyList",
    mixins: [JeecgListMixin],
    components: {
      MyApplyModal,
      JInput,
      JSuperQuery,
      CommentsModal,
    },
    data() {
      return {
        allProcess:[],
        visible: false,
        confirmLoading: false,
        description: '这是我的申请页面',
        chartList:[],
        selectedChartData:{},
        queryParam: {
          formId:"",
          processNo:"",
          businessFormNo:"",
          applicationId:this.$store.getters.application.id,
          // userCode: this.$store.getters.userInfo.workNo,
          // taskListType: "AllMyRequest",
          beginDate: this.getBeginDate(),
          endDate: this.getEndDate(),
        },
        url: {
          list: "/sys/bpm/process/applyProcess",
          delete: "/sys/wfapi/deleteProcess",
          withdrawUrl: "/sys/wfapi/pageToRunProcess",
        },
        /* 分页参数 */
        ipagination:{
            current: 1,
            pageSize: 10,
            pageSizeOptions: ['10', '20', '30'],
            showTotal: (total, range) => {
              return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
            },
            showQuickJumper: true,
            showSizeChanger: true,
            total: 0
        },
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },

      columns() {
        if (this.language) {
          return [
            /*{
              title: "processGuid",
              align: "center",
              dataIndex: 'processGuid',
              sorter: true
            },*/
            {
              title: this.language['eletronicSigned.processName'],
              align: "center",
              dataIndex: 'processName',
              width: 200,
              sorter: true
            },
            {
              title: this.language['eletronicSigned.processStatus'],
              align: "center",
              dataIndex: 'processStatus_dictText',
              // customRender: function (text, r, index) {
              //   if (text === 'Cancelled') {
              //     // return this.tt.language['eletronicSigned.termination']
              //     // return this.termination;
              //     // return '终止'
              //     // return this.getLanguage('eletronicSigned.termination')
              //     return this.language['eletronicSigned.processName'];
              //     // return this.language('eletronicSigned.termination');
              //   } else {
              //     return r.process_status_local_lang;
              //   }
              // }
              // scopedSlots: {customRender: 'processStatus'},
            },
            {
              title: this.language['eletronicSigned.processNo'],
              align: "center",
              dataIndex: 'processNo',
            },
            {
              title: this.language['eletronicSigned.businessFormNo'],
              align: "center",
              dataIndex: 'businessFormNo',
              // scopedSlots: {customRender: 'businessFormNo'},
            },
            {
              title: this.language['eletronicSigned.readyTaskText'],
              align: "center",
              dataIndex: 'readyTaskName',
              customRender: function (text, r, index) {
                if (text === '') {
                  return "-";
                }else{
                  return text;
                }
              }
            },
            {
              title: this.language['eletronicSigned.processChart'],
              align: "center",
              width: 80,
              dataIndex: 'id',
              scopedSlots: {customRender: 'processChartLot'},
            },
            {
              title: this.language['eletronicSigned.startTime'],
              align: "center",
              dataIndex: 'startTime'
            },
            /*{
              title: this.language['eletronicSigned.urgentDegree'],
              align: "center",
              width: 150,
              dataIndex: 'urgent_degree'
            },*/
            {
              title: this.language['eletronicSigned.approveName'],
              align: "center",
              dataIndex: 'lastSignUserRealName'
            },
            {
              title: this.language['eletronicSigned.approveDate'],
              align: "center",
              dataIndex: 'lastSignDate'
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              scopedSlots: {customRender: 'action'},
              align: "center",
              width: 170,
              fixed: "right"
            }

          ]
        }
      }



    },
    created() {
      this.initAllprocess()
    },
    methods: {

      handle_cancel(record){
        /*let params = {
          "businessFormNo":record.businessFormNo,//單號
          "cancelUserId":this.$store.getters.userInfo.workNo,//中止人
          "remarks":""//中止原因
        }*/
        cancel(this,record)
        /*getAction("/sys/bpm-signed/cancelProcess/"+record.businessFormNo,params).then(res=>{
          if (res.success) {
            cancel(res.result.applicationCode,this,record)
          }
        })*/
      },
      /*handle_withdraw(record){
        getAction("/sys/processSigned/pfBpmModel/queryBymodelGuId?modelGuId="+record.modelGuid,{}).then(res=>{
          if (res.success) {
            withdraw(res.result.applicationCode,this,record)
          }
        })
      },*/
      handle_delete(record){
        let param = {
          formNo: record.business_form_no,
          applicationCode: record.process_guid,
          process_guid: record.process_guid,
        }
        getAction(this.url.delete, param).then((res) => {
          if (res.success) {
            this.$message.success(this.language['common.deleteSuccess'])
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      moment,
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar)
      },
      openChart(record) {
        getAction("/sys/bpm/processTask/getVOlistByProcessId",{processId:record.id}).then(res=>{
          if(res.success){
            this.selectedChartData = {...record}
            this.visible = true;
            this.chartList = res.result;
          }
        })
      },
      handleCancel(e) {
        this.visible = false;
      },
      search_reset() {
        this.queryParam = {
          modelGuid:"",
          processNo:"",
          businessFormNo:"",
          applicationId:this.$store.getters.application.id,
          // applicationCode:this.$store.getters.applicationCode,
          // userCode: this.$store.getters.userInfo.workNo,
          // taskListType: "AllMyRequest",
          beginDate: this.getBeginDate(),
          endDate: this.getEndDate(),
        },
          this.loadData(1);
      },
      initAllprocess(){
        getAction("/sys/bpm/model/querylist", {applicationId:this.$store.getters.application.id}).then((res) => {
          if (res.success) {
            let list = [];
            res.result.forEach(item=>{
              let map = {};
              map.formId = item.formId;
              map.formName = item.formName;
              list.push(map);
            })
            this.allProcess = list;
          } else {
          }
        })
      },

      getBeginDate(){
        let date= new Date();
        date.setMonth(date.getMonth() - 1)
        let day = date.getDate()>9?date.getDate():'0'+date.getDate();
        // let month = date.getMonth()>9?date.getMonth():(date.getMonth()!==0?'0'+date.getMonth():0);
        let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1);
        let year = date.getFullYear();
        /*if(month===0){
          year = year-1;
          month = 12;
        }*/
        return year+'-'+month+'-'+day;
      },
      getEndDate(){
        let date= new Date();
        let day = date.getDate()>9?date.getDate():'0'+date.getDate();
        let year = date.getFullYear()
        let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1);
        return year+'-'+month+'-'+day;
      },

    }

  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>